import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './LoginPage.css';
import SEO from '../../components/SEO';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Please enter your email and password.');
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await axios.post(`${API_BASE_URL}/api/auth/login`, {
        email,
        password,
      });

      if (response.data?.token) {
        localStorage.setItem('wa_token', response.data.token);
      }

      navigate('/dashboard', { replace: true });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      setError(
        err.response?.data?.message || 'Unable to sign in. Please try again.'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="dashboard-auth-page">
      <SEO title="Dashboard login" noIndex canonicalPath="/dashboard/login" />
      <div className="dashboard-auth-overlay" />
      <div className="dashboard-auth-container">
        <div className="dashboard-auth-card">
          <div className="dashboard-auth-header">
            <h1 className="dashboard-auth-title">Whales Advisory</h1>
            <p className="dashboard-auth-subtitle">
              Secure access to your internal dashboard.
            </p>
          </div>

          <form className="dashboard-auth-form" onSubmit={handleSubmit}>
            <div className="dashboard-form-group">
              <label htmlFor="email" className="dashboard-form-label">
                Work email
              </label>
              <input
                id="email"
                type="email"
                className="dashboard-form-input"
                placeholder="you@whalesadvisory.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>

            <div className="dashboard-form-group">
              <label htmlFor="password" className="dashboard-form-label">
                Password
              </label>
              <input
                id="password"
                type="password"
                className="dashboard-form-input"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>

            {error && <p className="dashboard-form-error">{error}</p>}

            <button
              type="submit"
              className="dashboard-auth-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <p className="dashboard-auth-footer-text">
            This area is restricted to authorized team members.
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;

